import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress,
  Pagination
} from '@mui/material';

import CustomModal from '../components/modal/CustomModal';
import FormCreateTicket from '../components/forms/ticketForms/createTicket'
import { formatoFecha } from '../context/DateInstance';
import ReviewTicketForm from "../components/forms/ticketForms/reviewTicket"

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
// sections
// mock


import { UserListHead } from '../sections/@dashboard/user';

// hooks
import { useAxios } from '../context/AxiosHookContext';
import { useAuth } from '../context/AuthContext';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'Num. Solicitud', alignRight: false },
  { id: '', label: 'Detalle', alignRight: false },
  { id: '', label: 'Tipo de soporte', alignRight: false },
  { id: '', label: 'Departamento', alignRight: false },
  { id: '', label: 'Estatus', alignRight: false },
  { id: '', label: 'Técnico asignado', alignRight: false },
  { id: '', label: 'Fecha de solicitud', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------


export default function UserPage() {

  const [openModalActivities, setOpenModalActivities] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [activityList, setActivitiesList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})
  const [supportToReview, setSupportToReview] = useState(null)
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(null);

  const TICKETS_API = '/tickets'
  const TICKETS_API_PAGINATE = `${TICKETS_API}?&page=${page}&size=${10}&requester=${currentUser._id}&sortById=true`
  const axios = useAxios();


  const handleOpenMenu = (event, values) => {

    setOpen(event.currentTarget);

    const val = {
      ...values,
      _id: values._id,
      support_type: values.support_type._id,
      support_subtype: values.support_subtype._id,
      support_subtype_1: values.support_subtype_1._id,
      comment: values.comment,
      requester: values.requester._id
    }

    if (values.support_assigned && values.support_assigned._id) {
      val.support_assigned = values.support_assigned._id
    } else {
      delete val.support_assigned
    }

    if (values.support_created_by && values.support_created_by._id) {
      val.support_created_by = values.support_created_by._id
    } else {
      delete val.support_created_by
    }

    if (values.finished_date) {
      val.finished_date = values.finished_date
    }

    setValuesToEdit(val)
  };


  const handleCloseMenu = () => {
    setOpen(null);
  };

  const getNoReviewTicket = useCallback(async () => {
    try {

      const { data } = await axios.get(`${TICKETS_API}/noReview`);
      setSupportToReview(data?.data || null)

    } catch (error) {
      console.log(error);
    }
  }, [axios]);

  const getTickets = useCallback(async () => {
    try {
      setActivitiesList([])
      setLoading(true);
      const { data } = await axios.get(TICKETS_API_PAGINATE);
      setActivitiesList(data?.data?.list || []);
      setTotalPages(data?.data?.total_pages || 1)


    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, TICKETS_API_PAGINATE, setActivitiesList, setLoading]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };


  useEffect(() => {

    try {
      let ws = new WebSocket(process.env.REACT_APP_WS_URL);
    
      ws.onopen = (event) => {
        console.log("WebSocket connection opened:", event);
      };
    
      ws.onmessage = () => {
        getTickets();
      };
    
      ws.onclose = (event) => {
        console.log("WebSocket connection closed:", event);
        ws = new WebSocket(process.env.REACT_APP_WS_URL);
      };
    
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    
    } catch (error) {
      console.error("WebSocket error in try-catch:", error);
    }

  }, [getTickets]);

  

  useEffect(() => {
    getTickets();
  }, [getTickets, page])

  useEffect(() => {
    getNoReviewTicket()
  }, [getNoReviewTicket])


  return (
    <>

      <Helmet>
        <title>Mis tickets | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Mis tickets
          </Typography>
          <Button onClick={() => { setOpenModalActivities(true); setValuesToEdit({}) }} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Solicitar soporte
          </Button>
        </Stack>

        <Card>

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {activityList.length > 0 && activityList.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox">


                    <TableCell component="th" scope="row" padding="normal">
                      {`${row.departmentShortName || 'TIC'}-${row._id}`}
                    </TableCell>

                    <TableCell component="th" scope="row" padding="normal">
                      {row?.support_subtype_1?.displayName || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {row?.support_type?.displayName || 'En espera de asignación'}
                    </TableCell>

                    <TableCell align="left">
                      {row?.department ? `${row.department} (${row.departmentShortName})` : row?.departmentShortName || 'N/A'}
                    </TableCell>

                    <TableCell align="left">
                      {row.status === "Created" ? "Creado" : row.status === "Assigned" ? "Asignado" : "Finalizado"}
                    </TableCell>

                    <TableCell align="left">
                      {row?.support_assigned?.displayName || 'En espera de asignación'}
                    </TableCell>

                    <TableCell align="left">
                      <Label color={'success'} sx={{ textTransform: "none" }}>
                        {formatoFecha(row.created_date)}
                      </Label>
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (activityList.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />

        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalActivities(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>

      </Popover>


      <CustomModal
        open={openModalActivities}
        modalStyle={{ maxWidth: 800, minWidth: 440,maxHeight:700,overflowX:"auto" }}
        title={"Formulario de tickets de soporte"}
      >
        <FormCreateTicket
          onClose={() => setOpenModalActivities(false)}
          getValues={() => {
            getTickets();
            setOpenModalActivities(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>


      {supportToReview &&
        <CustomModal
          open={supportToReview}
          modalStyle={{ maxHeight: "70%", overflowX: "auto" }}
          title={"Encuesta de satisfacción"}
        >
          <>
            <ReviewTicketForm onClose={() => setSupportToReview(null)} ticket={supportToReview} getValues={() => { setSupportToReview(null) }} />
          </>
        </CustomModal>
      }

    </>
  );
}
